import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { authActions } from '@store/auth/auth.slice';

import { RouteEnum } from '@enum/route.enum';
import { Form } from '@form/common.style';
import { useLoginMfaMutation } from '@hook/auth/auth.hooks';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useStoreSelector } from '@hook/store/store.hooks';
import { LoginMFARequestInterface } from '@interface/auth/login.interface';
import { isString } from '@util/data/is-exist';

export const useLoginMfa = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<LoginMFARequestInterface>();
  const key = useStoreSelector((state) => state.auth.data.key ?? '');
  const { action: login, state } = useMutation(useLoginMfaMutation(), authActions, authActions.setData);

  const onLogin = () => form.validateFields().then((data) => login({ ...data, key }));

  useEffect(() => void (!isString(key) && navigate(RouteEnum.Login.path)), [key]);

  return {
    form,
    error: state.error,
    onLogin,
  };
};
